/* Template: Search
   ========================================================================== */

template.component.search = function() {

	const $search_toggle_btn = $('.search-toggle');
	const $search = $('.search-container');
	const search_toggle_open = 'search-toggle__open';
	const $search_close = $('#search-close');
	const $search_back = $('#search-back');
	const $main_navigation = $('.main-navigation');
	const $menu_toggle_btn = $('#menu-toggle');
	const $search_input = $('.search-box__form__input');

	// Search toggle
	$search_toggle_btn.click(function() {
		const window_width = window.innerWidth;

		$(this).toggleClass(search_toggle_open);
		$main_navigation.toggle();

		if ($search.is(':visible')) {
			$(this).attr('aria-expanded', 'false');
			$search_close.hide();
		} else {
			$(this).attr('aria-expanded', 'true');
			setTimeout(function() {
				$search_close.show();
			}, 200);
		}

		if (window_width < 768) {
			$search.show();
			$search_input.focus();
			$menu_toggle_btn.attr('aria-expanded', 'false');
		} else {
			$search.slideToggle();
			$search_input.focus();
		}

	});

	$search_close.click(function() {
		$search.slideUp();
		$search_close.hide();
		$search_toggle_btn.removeClass(search_toggle_open);
		$search_toggle_btn.attr('aria-expanded', 'false');

		if ($search.is(':visible')) {
			$search_toggle_btn.focus();
		}
	});

	$search_back.click(function() {
		$main_navigation.show().find('a:first').focus();
		$search.hide();
		$search_toggle_btn.removeClass(search_toggle_open);
		$search_toggle_btn.attr('aria-expanded', 'false');
		$menu_toggle_btn.attr('aria-expanded', 'true');
	});
};
